import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 3,
      name: i18n.t('tipos.metadata.fecha_factura'),
      value: 'Fecha de Factura'
    },
    {
      id: 4,
      name: i18n.t('tipos.metadata.importe_total'),
      value: 'Importe Total'
    },
    {
      id: 5,
      name: i18n.t('tipos.metadata.cif_propietario'),
      value: 'CIF Propietario'
    },
    {
      id: 6,
      name: i18n.t('tipos.metadata.num_factura'),
      value: 'Número de Factura'
    },
    {
      id: 7,
      name: i18n.t('tipos.metadata.num_serie_factura'),
      value: 'Número de serie de Factura'
    },
    {
      id: 8,
      name: i18n.t('tipos.metadata.fecha_operacion'),
      value: 'Fecha de Operación'
    },
    {
      id: 9,
      name: i18n.t('tipos.metadata.preiodo_facturacion_inicio'),
      value: 'Período de Facturación Inicio'
    },
    {
      id: 10,
      name: i18n.t('tipos.metadata.pago'),
      value: 'Forma de Pago'
    },
    {
      id: 11,
      name: i18n.t('tipos.metadata.moneda'),
      value: 'Moneda de la operación'
    },
    {
      id: 12,
      name: i18n.t('tipos.metadata.envio'),
      value: 'Forma de envío'
    },
    {
      id: 13,
      name: i18n.t('tipos.metadata.descripcion'),
      value: 'Descripción del producto'
    },
    {
      id: 14,
      name: i18n.t('tipos.metadata.cantidad'),
      value: 'Cantidad del producto'
    },
    {
      id: 15,
      name: i18n.t('tipos.metadata.importe_producto'),
      value: 'Importe del producto'
    },
    {
      id: 17,
      name: i18n.t('tipos.metadata.referencia_emisor'),
      value: 'Referencia del contrato emisor'
    },
    {
      id: 18,
      name: i18n.t('tipos.metadata.referencia_receptor'),
      value: 'Referencia del contrato receptor'
    },
    {
      id: 19,
      name: i18n.t('tipos.metadata.referencia_operacion'),
      value: 'Referencia de la operación'
    },
    {
      id: 20,
      name: i18n.t('tipos.metadata.referencia_expediente'),
      value: 'Referencia del expediente'
    },
    {
      id: 21,
      name: i18n.t('tipos.metadata.referencia_albaran'),
      value: 'Referencia del albarán'
    },
    {
      id: 22,
      name: i18n.t('tipos.metadata.bruto'),
      value: 'Total Bruto'
    },
    {
      id: 23,
      name: i18n.t('tipos.metadata.descuento'),
      value: 'Descuentos'
    },
    {
      id: 24,
      name: i18n.t('tipos.metadata.cargo'),
      value: 'Cargos'
    },
    {
      id: 25,
      name: i18n.t('tipos.metadata.suplidos'),
      value: 'Suplidos'
    },
    {
      id: 26,
      name: i18n.t('tipos.metadata.gastos_financieros'),
      value: 'Gastos Financieros'
    },
    {
      id: 27,
      name: i18n.t('tipos.metadata.anticipos'),
      value: 'Anticipos'
    },
    {
      id: 28,
      name: i18n.t('tipos.metadata.retencion'),
      value: 'Retención general'
    },
    {
      id: 29,
      name: i18n.t('tipos.metadata.numero_pedido'),
      value: 'Número de pedido'
    },
    {
      id: 30,
      name: i18n.t('tipos.metadata.nombre_emisor'),
      value: 'Nombre del Emisor'
    },
    {
      id: 31,
      name: i18n.t('tipos.metadata.cif_emisor'),
      value: 'CIF del Emisor'
    },
    {
      id: 32,
      name: i18n.t('tipos.metadata.nombre_receptor'),
      value: 'Nombre del Receptor'
    },
    {
      id: 33,
      name: i18n.t('tipos.metadata.cif_receptor'),
      value: 'CIF del Receptor'
    },
    {
      id: 34,
      name: i18n.t('tipos.metadata.nombre_cesionario'),
      value: 'Nombre del Cesionario'
    },
    {
      id: 35,
      name: i18n.t('tipos.metadata.cif_cesionario'),
      value: 'CIF del Cesionario'
    },
    {
      id: 36,
      name: i18n.t('tipos.metadata.numero_centro_admin'),
      value: 'Número de Centro Administrativo'
    },
    {
      id: 37,
      name: i18n.t('tipos.metadata.clase_impuesto'),
      value: 'Clase de Impuesto'
    },
    {
      id: 39,
      name: i18n.t('tipos.metadata.total_impuesto'),
      value: 'Total de Impuestos'
    },
    {
      id: 40,
      name: i18n.t('tipos.metadata.clase_retencion'),
      value: 'Clase de Retención'
    },
    {
      id: 42,
      name: i18n.t('tipos.metadata.total_retencion'),
      value: 'Total de Retenciones'
    },
    {
      id: 43,
      name: i18n.t('tipos.metadata.preiodo_facturacion_fin'),
      value: 'Período de Facturación Fin'
    },
  ]
}

export function TIPOS_METADATOS (state) {
  return configHelper.getConfig(state, 'TIPOS_METADATOS', GenerateConfig)
}
